import React from "react";
import { Row, Col, Image } from "react-bootstrap";


const HeaderColon = ({subtitle}) => {
  return (    
    <section className="header colon-retto p-4">
      <Row>
        <Col xs={12} md={4} className="text-center text-md-left">
          <Image src={`${process.env.REACT_APP_BASE_URL_PROD}/stsInternet/images/layout/web/logoEnte.jpg`} className="header-logo" />          
        </Col>
        <Col xs={12} md={8} className="col-header-title">          
          <h1 className="display-2 text-primary text-center">Con Te per la Prevenzione</h1>
          <h4 className="text-center" style={{ color:'steelblue' }}>{subtitle}</h4>
        </Col>
      </Row>
    </section>
  )
}

export default HeaderColon;